var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13 0C5.83158 0 0 5.83158 0 13C0 20.1684 5.83158 26 13 26C20.1684 26 26 20.1684 26 13C26 5.83158 20.1684 0 13 0ZM19.5888 10.2451L12.5472 17.2868C12.3359 17.498 12.0586 17.6042 11.7812 17.6042C11.5039 17.6042 11.2266 17.498 11.0153 17.2868L7.4945 13.7659C7.07092 13.3423 7.07092 12.6577 7.4945 12.2341C7.91808 11.8105 8.60275 11.8105 9.02633 12.2341L11.7812 14.989L18.057 8.71325C18.4806 8.28967 19.1653 8.28967 19.5888 8.71325C20.0124 9.13683 20.0124 9.8215 19.5888 10.2451Z","fill":"#FF2017"}));
}

Check.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = Check;

Check.default = Check;
